import { trackEvent } from './tracking';
export var changeUrl = function changeUrl(origin, destination, pageTitle) {
  var _window$IS;
  var newUrl = "".concat(origin, "/").concat(destination);
  window.history.pushState({}, 'agent_web_search', newUrl);
  document.title = pageTitle;
  var tracking = (_window$IS = window['IS24']) === null || _window$IS === void 0 || (_window$IS = _window$IS.TEALIUM) === null || _window$IS === void 0 ? void 0 : _window$IS.tracking;
  if (destination === paths.BRANCHENBUCH) {
    if (tracking) {
      tracking.updateCommonUtagData({
        pag_pagetitle: 'anbieter.index'
      });
    }
    trackEvent({
      label: "homepage_switch_to_realtor_directory_tab",
      name: 'homepage_to_realtor_directory_tab_switch'
    });
  }
  if (destination === paths.AGENT_SEARCH) {
    if (tracking) {
      tracking.updateCommonUtagData({
        pag_pagetitle: 'anbieter.agent-search.home'
      });
    }
    trackEvent({
      label: "homepage_switch_to_agent_search_tab",
      name: 'homepage_to_agent_search_tab_switch'
    });
  }
};
export var paths = {
  BRANCHENBUCH: 'anbieter/',
  AGENT_SEARCH: 'anbieter/immobilienmakler'
};
export var pageTitles = {
  BRANCHENBUCH: 'Immobilien-Branchenbuch: Makler, Bauträger, Verwalter finden',
  AGENT_SEARCH: 'Immobilienmakler gesucht? Makler finden bei ImmoScout24'
};